const logo = require('../images/logo3.png')

export default logo;